/** Scroll geometry of the thread viewport, in pixels. */
export interface ScrollMetrics {
  scrollHeight: number;
  scrollTop: number;
  clientHeight: number;
}

/** Inputs that decide whether the thread should snap to the bottom after a render. */
export interface AutoScrollInput {
  conversationChanged: boolean;
  wasAtBottom: boolean;
}

/** Distance (px) from the bottom within which the viewport counts as "at the bottom". */
export const AT_BOTTOM_THRESHOLD = 80;

/** True when the viewport is scrolled to (or near) the bottom. */
export function isNearBottom(metrics: ScrollMetrics, threshold = AT_BOTTOM_THRESHOLD): boolean {
  return metrics.scrollHeight - metrics.scrollTop - metrics.clientHeight < threshold;
}

/**
 * Snap to the bottom when the user switches conversations, or whenever the thread re-renders
 * while they were already following the bottom (new message, optimistic send, reload). Otherwise
 * preserve position — the user is reading history. Mirrors WhatsApp's behaviour.
 */
export function shouldAutoScroll(input: AutoScrollInput): boolean {
  return input.conversationChanged || input.wasAtBottom;
}
